import { useContext } from 'react';
import { CmpContext, CmpContextValue } from '@src/bootstrap/cmp/context.ts';

/**
 * Hook to access the Consent Management Platform context.
 * Must be used within a CmpProvider component.
 * @returns {CmpContextValue} Object containing consent status information
 * @throws {Error} If used outside of a CmpProvider
 */
export const useCmp = (): CmpContextValue => {
  const context = useContext(CmpContext);
  if (!context) {
    throw new Error('useCmp must be used within a CmpProvider');
  }
  return context;
};
